require('angular');

angular.module('app').service('promocode', function($http){
    this.addPromoCode = function(code, $scope){
        if(!!$scope){
            $scope.promocodeInfo = '';
        }

        code = code.replace(/ /g,"");
        if(code == ''){
            $scope.promocodeInfo = 'Please provide promo code';
            return false;
        }

        $(".shopping-cart-box").css("opacity", "0.3");
        $(".shopping-cart-box").css("pointer-events", "none");
        $http({
            method: 'POST',
            async: false,
            dataType: 'json',
            url: '/wp-admin/admin-ajax.php',
            params: {
                action: 'add-promocode',

            },
            data: {
                promocode: code
            }
        }).then(function(response){
            $(".shopping-cart-box").css("opacity", "1.0");
            $(".shopping-cart-box").css("pointer-events", "auto");

            if(!!$scope && response.data.success){
                $scope.promocodes.push({promocode:code});
                $scope.cart = response.data.cart;
                $scope.promocodeToAdd = '';
            }

            if(!response.data.success){
                $scope.promocodeInfo = response.data.message;
            }
        });
    },

    this.addPromoCodeWoCart = function(code, $scope){
        $http({
            method: 'POST',
            async: false,
            dataType: 'json',
            url: '/wp-admin/admin-ajax.php',
            params: {
                action: 'add-promocode-wo-cart',

            },
            data: {
                promocode: code
            }
        }).then(function(response){

        });
    },

    this.getPromoCodes = function(){

        return $http({
            method: 'POST',
            async: false,
            dataType: 'json',
            url: '/wp-admin/admin-ajax.php',
            params: {
                action: 'fetch-promocodes',

            }
        });
    },

    this.removePromoCode = function(promocode, $scope){
        if(!!$scope){
            $scope.promocodeInfo = '';
        }

        $(".shopping-cart-box").css("opacity", "0.3");
        $(".shopping-cart-box").css("pointer-events", "none");
        $http({
            method: 'POST',
            async: false,
            dataType: 'json',
            url: '/wp-admin/admin-ajax.php',
            params: {
                action: 'remove-promocode-cart'
            },
            data: {
                promocode: promocode
            }
        }).then(function(response){
            $(".shopping-cart-box").css("opacity", "1.0");
            $(".shopping-cart-box").css("pointer-events", "auto");
            let ret = [];
            angular.forEach($scope.promocodes, function(code, key) {
                if(code.promocode != promocode){
                    ret.push(code);
                }
            });

            $scope.promocodes = ret;
            $scope.cart = response.data.cart;
        });
    }


});